import config from 'constants/config'

export function isMetasearchDiscountEnabled(): boolean {
  return config.METASEARCH_DISCOUNT_ENABLED
}

export interface MetasearchDiscountRequestKeyContext {
  token: string
  propertyId: string
  checkIn: string
  checkOut: string
  occupancy: Array<string>
  price: number
}

export function buildMetasearchDiscountRequestKey(context: MetasearchDiscountRequestKeyContext): string {
  return [
    context.token,
    context.propertyId,
    context.checkIn,
    context.checkOut,
    context.occupancy.join('/'),
    context.price,
  ].join('|')
}

export function hasMetasearchDiscountContext(input: {
  token?: string
  propertyId?: string
  checkIn?: string
  checkOut?: string
  occupancy?: Array<string>
  price?: number
}): input is {
  token: string
  propertyId: string
  checkIn: string
  checkOut: string
  occupancy: Array<string>
  price: number
} {
  return !!(
    input.token &&
    input.propertyId &&
    input.checkIn &&
    input.checkOut &&
    input.occupancy?.length &&
    input.price &&
    input.price > 0
  )
}
